import { getPageUrl } from '../../../shared/constant/common-path';
import { PRODUCT_PATH } from '../../../shared/constant';
import { CategoryKindType } from '../../../shared/reducers/category';

import { MainSite } from '../../../main/interfaces/MainSection.interface';

interface Props {
  kind: CategoryKindType;
  code: string;
  mainSite?: MainSite;
}

export const getCategorySiteLink = ({
  kind,
  code,
  mainSite,
}: Props) => {
  const beautyQueryString = mainSite === 'BEAUTY' ? `&site=${mainSite.toLocaleLowerCase()}` : '';

  if (kind === 'product_collection') {
    return `${getPageUrl(PRODUCT_PATH.list)}?collection=${code}${beautyQueryString}`;
  }
  return `${getPageUrl(PRODUCT_PATH.list)}?category=${code}${beautyQueryString}`;
};
